import { Link } from 'react-router-dom'
import { useState } from 'react'
import { useAuthStore } from '../../store/authStore'

interface HeaderProps {
  onMenuClick: () => void
}

export function Header({ onMenuClick }: HeaderProps) {
  const { user, signOut } = useAuthStore()
  const [showUserMenu, setShowUserMenu] = useState(false)

  return (
    <header className="md:hidden flex items-center justify-between p-4 bg-surface border-b border-border-color sticky top-0 z-30 shadow-sm">
      {/* Logo */}
      <div className="flex items-center gap-2">
        <img src="/logo.png" alt="Kalypso AI" className="size-8 rounded-lg object-cover" />
        <span className="font-bold text-primary-dark font-serif">Kalypso AI</span>
      </div>

      {/* Menu Button */}
      <button
        onClick={onMenuClick}
        className="p-2 text-text-main"
      >
        <span className="material-symbols-outlined">menu</span>
      </button>

      {/* Hidden User Menu - keeping for functionality */}
      <div className="hidden">
        <div className="relative">
          <button
            onClick={() => setShowUserMenu(!showUserMenu)}
            className="p-2 -mr-2 rounded-lg hover:bg-surface-muted"
          >
            {user?.avatarUrl ? (
              <img
                src={user.avatarUrl}
                alt={user.name || 'User'}
                className="w-8 h-8 rounded-full object-cover"
              />
            ) : (
              <span className="material-symbols-outlined">account_circle</span>
            )}
          </button>

          {showUserMenu && (
            <>
              <div
                className="fixed inset-0 z-40"
                onClick={() => setShowUserMenu(false)}
              />
              <div className="absolute right-0 mt-2 w-48 bg-white rounded-xl shadow-hover border border-border z-50">
                <div className="p-3 border-b border-border">
                  <p className="font-medium truncate">{user?.name || 'User'}</p>
                  <p className="text-sm text-text-muted truncate">{user?.email}</p>
                </div>
                <div className="p-2">
                  <Link
                    to="/settings"
                    className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-surface-muted"
                    onClick={() => setShowUserMenu(false)}
                  >
                    <span className="material-symbols-outlined text-lg">settings</span>
                    Settings
                  </Link>
                  <button
                    onClick={() => {
                      signOut()
                      setShowUserMenu(false)
                    }}
                    className="w-full flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-surface-muted text-left"
                  >
                    <span className="material-symbols-outlined text-lg">logout</span>
                    Sign Out
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </header>
  )
}
